import type { ServiceEventType } from '../../types';

type EventTypeLabelStrings = {
    EVENT_TYPE_CALIBRATED: string;
    EVENT_TYPE_INSPECTED: string;
    EVENT_TYPE_REPLACED: string;
    EVENT_TYPE_SERVICED: string;
};

export const getEventTypeLabels = (
    strings: EventTypeLabelStrings
): Record<ServiceEventType, string> => ({
    calibrated: strings.EVENT_TYPE_CALIBRATED,
    inspected: strings.EVENT_TYPE_INSPECTED,
    replaced: strings.EVENT_TYPE_REPLACED,
    serviced: strings.EVENT_TYPE_SERVICED
});
